import { sha256 } from 'js-sha256';

export function findNonce(prefix: string, difficulty: number): number {
	const maxAttempts = maxNonceAttempts(difficulty);

	for (let nonce = 0; nonce <= maxAttempts; nonce += 1) {
		const hash = sha256.arrayBuffer(`${prefix}:${nonce}`);

		if (hasLeadingZeroBits(hash, difficulty)) {
			return nonce;
		}
	}

	throw new Error('Failed to find nonce');
}

function maxNonceAttempts(difficulty: number, failureProbability = 1e-6) {
	if (difficulty < 0) {
		throw new Error('Difficulty must be non-negative.');
	}
	if (failureProbability <= 0 || failureProbability >= 1) {
		throw new Error('Failure probability must be between 0 and 1.');
	}

	const successProbability = 2 ** -difficulty;
	const maxAttempts = Math.log(failureProbability) / Math.log(1 - successProbability);

	return Math.ceil(maxAttempts);
}

function hasLeadingZeroBits(hash: ArrayBuffer, difficulty: number): boolean {
	let remaining = difficulty;

	for (const byte of new Uint8Array(hash)) {
		if (remaining <= 0) {
			return true;
		}
		if (remaining >= 8) {
			if (byte !== 0) {
				return false;
			}
			remaining -= 8;
		} else {
			const shift = 8 - remaining;
			return Math.floor(byte / 2 ** shift) === 0;
		}
	}
	return remaining <= 0;
}
